<template>
  <van-row
    type="flex"
    :class="['teacher-item', {float}]"
    @click="chooseTeacherHandler"
  >
    <van-col class="avatar">
      <lazy-component class="lazy-component">
        <van-image
          round
          width="100%"
          height="100%"
          :src="item.avatar"
        />
      </lazy-component>
    </van-col>
    <van-col class="info">
      <p class="name">{{ item.name }}</p>
      <span class="label">{{ item.title }}</span>
    </van-col>
  </van-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TeacherItem',
  props: {
    float: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  methods: {
    ...mapActions(['updateTeacher']),
    chooseTeacherHandler () {
      this.updateTeacher(this.item)
      this.$router.push({
        name: 'teacher-home',
        params: {
          teacherId: this.item.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-item {
  @include wh(100%, 78px);
  padding: 4px;
  background-size: contain;
  background-position: right top;
  background-repeat: no-repeat;
  &.float {
    .avatar {
      position: relative;
      &::before {
        content: " ";
        position: absolute;
        top: 10px;
        left: 0;
        width: 70px;
        height: 70px;
        background: #CCCCCC;
        border-radius: 50%;
        filter: blur(12px);
      }
    }
  }
  .avatar {
      @include wh(70px, 70px);
      min-width: 70px;
      .lazy-component {
        @include wh(100%, 100%);
      }
    }
  .info {
    height: 100%;
    padding: 14px 16px;
    .name {
      @include sc($font-size-xlg, $color-text-heavy);
      @include lw(18px, 500);
      margin-bottom: 12px;
    }
    .label {
      @include sc($font-size-base, $color-text-light);
      @include lw(18px);
      @include ellipsis(1, 14px);
    }
  }
}
</style>
